// ServiceProvider.jsx
import React, { useState } from 'react';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { Toaster } from 'react-hot-toast';

function ServiceProvider() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState('dashboard');

    return (
        <div className="bg-gray-50 font-sans antialiased min-h-screen">
            {/* Mobile Overlay */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <Sidebar
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isOpen={sidebarOpen}
                setIsOpen={setSidebarOpen}
            />

            <div className="main-content lg:ml-[72px] transition-all duration-200">
                <Header
                    currentPage={currentPage}
                    sidebarOpen={sidebarOpen}
                    setSidebarOpen={setSidebarOpen}
                />

                <div className="p-4 sm:p-6 lg:p-8">
                    {/* Coming Soon Content */}
                    <div className="flex flex-col items-center justify-center min-h-[60vh]">
                        <div className="text-center">
                            {/* Icon */}
                            <div className="mb-6">
                                <svg 
                                    className="w-24 h-24 mx-auto text-blue-500" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24"
                                >
                                    <path 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                        strokeWidth="1.5" 
                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" 
                                    />
                                </svg>
                            </div>
                            
                            {/* Title */}
                            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
                                Coming Soon
                            </h1>
                            
                            {/* Subtitle */}
                            <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
                                We're working on something amazing. Stay tuned for updates!
                            </p>
                            
                            {/* Decorative Line */}
                            <div className="w-24 h-1 bg-blue-500 mx-auto rounded-full"></div>
                            
                            {/* Optional: Additional info */}
                            <p className="mt-6 text-sm text-gray-400">
                                Service Provider page is under development
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Toaster position="top-right" />
        </div>
    );
}

export default ServiceProvider;